<template>
  <el-dialog
  :visible="visible"
  :fullscreen="true"
  :close-on-press-escape="false"
  :show-close="false"
  append-to-body
  center
  v-loading.fullscreen.lock="fullScreenLoading"
  @open="open">
  <span slot="title" class="dialog-header">
    <span v-if="!isEditionMode()" class="title" >{{$t('contacts.newContact')}}</span>
    <span v-if="isEditionMode()" class="title" >{{$t('contacts.editContact')}}</span>
  </span>
  <el-row :gutter="20" style="margin-bottom:20px;">
    <el-col>
      <el-steps :active="step" align-center>
        <el-step  icon="el-icon-user"></el-step>
        <el-step  icon="el-icon-location-information"></el-step>
        <el-step  icon="el-icon-notebook-2"></el-step>
      </el-steps>
    </el-col>
  </el-row>
  <el-divider />
  <el-row justify="center">
    <el-col class="formContainer" :xs="24" :sm="24" :md="18" :lg="18" :xl="18">
      <el-form ref="individualContactForm" :model="contact" :rules="rules.individual" style="max-width:1000px;" label-position="top">
        <div v-if="step==0">
          <el-row :gutter="20">
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
              <el-form-item prop="sex" :label="$t('contacts.gender')">
                <el-radio-group v-model="contact.sex" size="medium">
                  <el-radio-button label="1">{{$t('contacts.genderMale')}}</el-radio-button>
                  <el-radio-button label="0">{{$t('contacts.genderFemale')}}</el-radio-button>
                  <el-radio-button label="2">{{$t('contacts.genderOther')}}</el-radio-button>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
              <el-form-item prop="title" :label="$t('contacts.contactTitleField')">
                <el-select v-model="contact.denomination" :placeholder="$t('contacts.chooseTitle')" value-key="id">
                  <el-option
                    v-for="item in denominations"
                    :key="item.id"
                    :label="item.name[lang]"
                    :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
              <el-form-item prop="first_name" :label="$t('contacts.firstName')">
                <el-input v-model="contact.first_name" ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
              <el-form-item  :label="$t('contacts.lastName')">
                <el-input v-model="contact.last_name" ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
              <el-form-item prop="email" :label="$t('contacts.email')" >
                    <slot scope="error">
                      <span v-if="emailError"><i class="el-icon-warning"></i> {{emailError}}</span>

                    </slot>
                <el-input v-model="contact.email"  suffix-icon="el-icon-message" @change="validateEmail"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
              <el-form-item :label="$t('contacts.phone')">
                <PhoneComponent :data="{phone : phoneNumber, ext:contact.phone_ext}" @updatePhone="v => phoneNumber=v" @updateExt="v => contact.phone_ext=v"></PhoneComponent>
                <!-- <el-input v-model="phoneNumber"  suffix-icon="el-icon-phone"></el-input> -->
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-form-item :label="$t('contacts.tags')">
              <el-select
                  v-model="contact.tags"
                  multiple
                  filterable
                  allow-create
                  :placeholder="$t('contacts.tags')"
                  value-key="id">
                  <el-option
                    v-for="item in listTags"
                    :key="item.id"
                    :label="item.code"
                    :value="item">
                  </el-option>
                </el-select>
            </el-form-item>
          </el-row>
          <el-row :gutter="0" v-if="!isEditionMode()">
            <el-col>
              <el-form-item :label="$t('contacts.notes')" >
                <quill-editor v-model="contact.notes" ref="noteEditor" :options="editorOptions"></quill-editor>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div v-if="step==1">
          <el-col v-for="(address, index) in getAddresses" :key="index" :xs="24" :sm="24" :md="24" :lg="12" :xl="12" style="padding:5px;">
             <AddressCard :address="address" :index="index" @remove="removeAddress" @change="changeAddress" @clickToAdd="disableCtrl" @cancel="enableCtrl"></AddressCard>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" style="margin-top:10px;margin-bottom:10px;">
            <AddressFlatEditor @add="addAddress" @change="replaceAddress" :addressToEdit="addressToEdit" @clickToAdd="disableCtrl" @cancel="enableCtrl"></AddressFlatEditor>
          </el-col>
        </div>
        <div v-if="step==2">
          <h4>{{ $t('contacts.information') }}</h4>
          <el-row :gutter="20">
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
              <span>{{$t('contacts.firstNameField')}} </span><span>{{contact.first_name}}</span>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
              <span>{{$t('contacts.lastNameField')}} </span><span>{{contact.last_name}}</span>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
              <span>{{$t('contacts.emailField')}} </span><span>{{contact.email}}</span>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
              <span>{{$t('contacts.phoneField')}}: </span><span>{{contact.phone}}</span>
              <span> Ext.: </span><span>{{contact.phone_ext}}</span>
            </el-col>
          </el-row>
          <el-row>
            <h4>{{$t('contacts.tags')}}</h4>
            <span v-if="contact.tags!= null && contact.tags.length === 0">S.O.</span>
            <el-tag v-for="tag in contact.tags" :key="tag.id" style="margin:5px;">{{tag.code || tag}}</el-tag>
          </el-row>
          <el-row v-if="!isEditionMode()">
            <h4>{{$t('contacts.notes')}}</h4>
            <el-col>
              <span v-if="contact.notes == null || contact.notes=='' ">S.O.</span>
              <div v-html="contact.notes"/>
            </el-col>
          </el-row>
          <el-row>
            <h4>{{$t('contacts.addresses')}}</h4>
            <span v-if="getAddresses!=null && getAddresses.length===0">Aucune adresse spécifiée</span>
            <el-col v-for="(address, index) in getAddresses" :key="index" :xs="24" :sm="24" :md="24" :lg="12" :xl="12" style="padding:5px;">
               <AddressCard :address="address" :index="index" :ctrlVisible="false"></AddressCard>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </el-col>
  </el-row>

  <span slot="footer" class="dialog-footer card-shadow--large">
    <el-button v-if="step>0" type="primary" @click="step--" :disabled="ctrlDisabled"><i class="el-icon-back"/></el-button>
    <el-button @click="close">{{$t('common.Cancel')}}</el-button>
    <el-button v-if="!isEditionMode() && step==2" type="primary" @click="save" :disabled="ctrlDisabled">{{ $t('common.confirm') }}</el-button>
    <el-button v-if="isEditionMode() && step==2" type="primary" @click="save" :disabled="ctrlDisabled">{{ $t('common.Edit') }}</el-button>
    <el-button v-if="step<2" type="primary" @click="nextStep" :disabled="ctrlDisabled"><i class="el-icon-right"/></el-button>
  </span>
</el-dialog>
</template>
<script>
import axios from "axios"
import { AsYouType } from 'libphonenumber-js'
import AddressCard from '@/components/address/Address-Card'
import AddressFlatEditor from '@/components/address/Address-Flat-Editor'
import SystemApi from '@/services/API/system'
import PhoneComponent from '@/components/phone.vue'
import PortausAdminAPI from '@/services/API/portaus-admin'

export default {
  name: 'ContactEditor',
	props: {
		visible : Boolean,
    contactToEdit : Object,
	},
  data() {
    return {
      listTags : [],
      contact : {
        birthDate : null,
        sex : null,
        first_name : '',
        last_name : '',
        email : '',
        phone : '',
        phone_ext : null,
        denomination : null,
        notes : '',
        addresses : [],
        tags:[]},
      step:0,
      emailError:null,
      fullScreenLoading : false,
      addressFormVisible : false,
			addressToEdit : null,
			addressIdToEdit : null,
      ctrlDisabled : false,
      denominations : [],
      editorOptions: {
				theme: 'snow',
				modules: {
					toolbar: [
						['bold', 'italic', 'underline', 'strike'],
						[{ 'header': [1, 2, 3, false] }],
					]
				}
			},
      rules : {
  	  	individual : {
  	  		first_name : [
  	  			{ required: true, message: 'Veuillez saisir un prénom', trigger: 'blur' }
    			],
          sex : [
  	  			{ required: true, message: 'Veuillez sélectionner un genre', trigger: 'blur' }
    			],
  	  		last_name : [
  	  			{ required: true, message: 'Veuillez saisir un nom', trigger: 'blur' }
  	  		],
  				fk_country_id : [
  	  		 	{ required: true, message: 'Veuillez sélectionner un pays', trigger: 'blur' }
  	  		],
  	  		email : [
  	  			{ type: 'email', message: "Format de l'adresse courriel incorrect", trigger: ['blur', 'change'] }
  	  		]
  	  	}
  	  }
    };
  },components: {
    AddressCard,
    AddressFlatEditor,
    PhoneComponent
  },
	methods: {
    fetchDenominations(){
      return PortausAdminAPI.fetchDenominations()
        .then((denominations) =>  {
          this.denominations = denominations
        })
    },
    addCurrentTagIfNotPresent(listTags, currentTags){
      _.forEach(currentTags, t=>{
        let tagFound = _.find(listTags, t2=>{return t2.code==t.code});
        if(tagFound==null){
          this.listTags.push(t);
        }
      })
    },
    fetchTags(){
      return SystemApi.getTags('CONTACT',true)
        .then(tags=>{
          // console.log("tags : ", tags);
          this.listTags = tags;
        })
    },
    disableCtrl(){
      this.ctrlDisabled=true;
    },
    enableCtrl(){
      this.ctrlDisabled=false;
    },
    isEditionMode(){
      return this.contactToEdit!=null;
    },
    resetFields(){
      this.contact.first_name = '';
      this.contact.last_name = '';
      this.contact.email = '';
      this.contact.phone = '';
      this.contact.ext = null;
      this.contact.sec = null;
      this.contact.denomination = null;
      this.contact.notes = '';
      this.contact.addresses = [];
      this.contact.tags = [];
      this.step=0;
      this.ctrlDisabled = false;
    },
    nextStep(){
      this.fullScreenLoading=true;
      if(this.step==0){
        this.validateStep0()
          .then(valid=>{
            if(valid)this.step++;
            this.fullScreenLoading=false;
          }).catch(notValid=>{
            this.fullScreenLoading=false;
          })
      }else{
        this.step++;
        this.fullScreenLoading=false;
      }
    },
    addAddress(address){
      this.ctrlDisabled=false;
			this.contact.addresses.push(address);
			// this.closeAddressForm();
		},
    changeAddress({index, address}){
      this.ctrlDisabled=false;
      Object.assign(this.contact.addresses[index], address);
    },
		replaceAddress(address){
      this.ctrlDisabled=false;
			this.addressToEdit = null;
			var tmp = [];
			_.forEach(this.contact.addresses, (add, i)=>{
				if(i==this.addressIdToEdit){
					tmp.push(address);
				}else{
					tmp.push(add);
				}
			})
			this.addressIdToEdit = null;
			this.contact.addresses = tmp;
			this.closeAddressForm();
		},
		removeAddress(index){
			this.$confirm("Voulez-vous retirer cette adresse ?", "", {
				confirmButtonText: 'Oui',
				cancelButtonText: 'Annuler',
				type: 'warning',
				center: true
			}).then(() => {
				this.contact.addresses.splice(index,1)
			})

		},
    openAddessForm(){
			this.addressFormVisible=true;
		},
    closeAddressForm(){
			this.addressFormVisible=false;
			this.addressToEdit = null;
			this.addressIdToEdit = null;

		},
    open(){
      this.step=0;
      this.fetchTags()
        .then(()=>{
          if(this.contactToEdit!=null){
            this.addCurrentTagIfNotPresent(this.listTags, this.contactToEdit.tags);
          }
        })
      if(this.isEditionMode()){
        Object.assign(this.contact, this.contactToEdit);
      }
    },
    close(){
      this.$emit('close');
      this.resetFields();
      this.$refs.individualContactForm.resetFields();
    },
    validateStep0(){
      return this.$refs['individualContactForm'].validate();
    },
    validateEmail(){
      let excludedContactId = this.contactToEdit!=null ? this.contactToEdit.id : undefined;
      let params = {email:this.contact.email, excludedContactId}

      if(this.contact.email!=null && this.contact.email!=''){
        return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/contacts/validate-email", {params})
          .then(()=>{
            this.emailError = null;
          }).catch(err=>{
            this.emailError = "Un contact existe déjà avec cette adresses courriel"
          })
      }

    },
    createContact(){
      return axios.post(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/contacts", this.contact)
        .then(response=>{
          this.$store.dispatch('CONTACTS_INVALIDATE_LIST');
          this.$message.success('Le contact a été créé avec succès');
          return response.data;
        })
    },
    updateContact(){
      return axios.put(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/contacts/"+this.contact.id, this.contact)
        .then(response=>{
          this.$store.dispatch('CONTACTS_INVALIDATE_LIST');
          this.$message.success('Le contact a été modifié avec succès');
          return response.data;
        })
    },
    save(){
      this.$refs['individualContactForm'].validate((valid)=>{
        if(valid){
          if(this.isEditionMode()){
            this.updateContact()
              .then(contactModified=>{
                this.$emit('edited',contactModified);
                this.close();
              }).catch(err=>{
                // console.log(err);
                if(err.response.status == 403){
                  this.$message.error('Impossible de créer le contact car un contact existe déjà avec ce courriel ' + this.contact.email);
                }
              })
          }else{
            this.createContact()
              .then(contact=>{
                this.$emit('created',contact);
                this.close();
              }).catch(err=>{
                if(err.response.status == 403){
                  this.$message.error('Impossible de créer le contact car un contact existe déjà avec ce courriel ' + this.contact.email);
                }
              })
          }
        }
      });
    },

	},
	computed: {
    lang(){
      return this.$i18n.locale
    },
    phoneNumber: {
			set(phone){this.contact.phone=phone;},
      get(){
				if(this.contact!=null && this.contact.phone!=null &&this.contact.phone.length<=4)return this.contact.phone;
        if (_.get(this, 'contact.phone') != null) {
          return new AsYouType('CA').input(_.get(this, 'contact.phone'));
        }
        this.contact.phone;
			}
		},
    getAddresses(){
			return this.contact.addresses;
		}

	},
  mounted(){
    this.fetchDenominations();
  },
}
</script>
<style lang="scss" scoped>
@import '../../assets/scss/_variables';


.dialog-footer{
  position: fixed;
  display: block;
  bottom: 0px;
  width: 100%;
  background-color: #f3f7fa;
  height:50px;
  margin-left:-20px;
  padding-top:10px;
  border-top:1px solid #E4E7ED;
  z-index:100;
}

.el-input__inner{
  border:0px;
}
.title {
	font-size : 1.6em;
	font-weight:bold;

}
.product{
  line-height:20px;

  .qty{
    float:right;
    position:relative
  }
  .empty {
    color:red;
  }
}

.formContainer{
    margin-left:15%;
    width:70%;
  }


@media (max-width: 1366px) {
  .formContainer{
      margin-left:10%;
      width:80%;
    }
}

@media (max-width: 1024px) {
  .formContainer{
      margin-left:2%;
      width:98%;
    }
}

</style>
